module.exports = __webpack_public_path__ + "img/top-up-is-on-the-way.84448e1.svg";